import React, { createContext, useReducer, useEffect, useState, useContext } from 'react'
import CookiePopup from './CookiePopup'

const COOKIE_NAME = 'consent'

const CookieConsentStateContext = createContext()

function getCookie() {
  const regex = new RegExp(`(?:(?:^|.*;\\s*)${COOKIE_NAME}\\s*\\=\\s*([^;]*).*$)|^.*$`)
  const cookie = document.cookie.replace(regex, "$1");
  return cookie.length ? JSON.parse(cookie) : undefined
}

// Initial value is cookie value OR prefered value but not yet set
let initialCookieValue = getCookie() || {
  isSet: 0,
  marketing: 1
}

const CookieConsentProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'acceptCurrent':
        return {
          marketing: 1,
          isSet: 1,
        }
      case 'declineAll':
        return {
          isSet: 1,
          marketing: 0,
        }
      case 'showCookiePopup':
        return state
      default:
        throw new Error()
    }
  }, initialCookieValue)



  // Update the cookie when state changes
  useEffect(() => {
    document.cookie = `${COOKIE_NAME}=${JSON.stringify(state)}`
    if(state.isSet) {   
      //document.cookie = `ba_vid=${1};max-age=${60*60*24*365*1.5} `
      //document.cookie = `ba_sid=${1};max-age=${60*30}`
    }
  }, [state])

  return (
    <CookieConsentStateContext.Provider value={state}>
        {(!state.isSet && window.location.pathname.startsWith(process.env.PUBLIC_URL + '/event')) && <CookiePopup dispatch={dispatch} />}
        {children}
    </CookieConsentStateContext.Provider>
  )

}


export { CookieConsentProvider, CookieConsentStateContext }